import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    Chip
} from "@mui/material";
import { useEffect, useState } from "react";

const REPORT_REASONS = [
    "영리목적/홍보성",
    "음란성/선정성",
    "욕설/인신공격",
    "도배",
    "기타"
];

export default function ReportDialog({ open, onClose, onSubmit, targetId, targetName }) {
    const [selected, setSelected] = useState(Array(REPORT_REASONS.length).fill(false));
    const [etcContent, setEtcContent] = useState("");

    useEffect(() => {
        if (open) {
            setSelected(Array(REPORT_REASONS.length).fill(false));
            setEtcContent("");
        }
    }, [open])

    /// ✅ 버튼 선택
    const handleSelect = (index) => {
        const updated = [...selected];
        updated[index] = !updated[index];
        setSelected(updated);
    };

    /// ✅ 신고하기
    const handleSubmit = () => {
        if (!selected.includes(true)) {
            alert("사유를 하나 이상 선택해주세요.");
            return;
        }

        if (selected[4] && etcContent.trim() === "") {
            alert("기타 내용을 입력해주세요.");
            return;
        }

        const reasons = REPORT_REASONS.map((item, idx) =>
            selected[idx] ? (idx === 4 ? etcContent.trim() : item) : null
        ).filter(Boolean).join(", ");

        onSubmit(targetId, targetName, reasons);
        alert("신고가 접수됐습니다.");
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>신고하기</DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={1}>
                    {REPORT_REASONS.map((text, idx) => (
                        <Grid item xs={6} key={idx}>
                            <Chip
                                label={text}
                                clickable
                                onClick={() => handleSelect(idx)}
                                color={selected[idx] ? "primary" : "default"}
                                variant={selected[idx] ? "filled" : "outlined"}
                                sx={{ width: "100%" }}
                            />
                        </Grid>
                    ))}
                </Grid>

                {selected[4] && (
                    <TextField
                        label="기타 내용"
                        fullWidth
                        multiline
                        rows={4}
                        margin="normal"
                        value={etcContent}
                        onChange={(e) => setEtcContent(e.target.value)}
                    />
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>취소</Button>
                <Button onClick={handleSubmit} variant="contained" color="primary">
                    신고하기
                </Button>
            </DialogActions>
        </Dialog>
    );
}
